<div class="d-flex jc-center fd-col ai-center h-100vh">
  <mat-card
    class="dialog-card dialog-wrapper"
    [class.top-to-bottom]="isClosed"
    [class.bottom-to-top]="!isClosed"
  >
    <mat-card-content class="dialog-content" *ngIf="!isDownloadPreview">
      <nav class="template-modal__nav">
        <section class="template-nav__heading">Select Template</section>
        <section class="template-nav__icon">
          <mat-icon (click)="closeDialogRef()">close</mat-icon>
        </section>
      </nav>
      <div class="template-type-tabs">
        <button 
          class="template-type-tab" 
          [class.active]="selectedTemplateFormat === 'excel'"
          (click)="onTemplateTypeChange('excel')"
        >
          Excel
        </button>
        <button 
          class="template-type-tab" 
          [class.active]="selectedTemplateFormat === 'xml'"
          (click)="onTemplateTypeChange('xml')"
        >
          XML
        </button>
        <button
          *ngIf="isAsaFolder"
          class="template-type-tab"
          [class.active]="selectedTemplateFormat === 'txt'"
          (click)="onTemplateTypeChange('txt')"
        >
          TXT
        </button>
      </div>

      <!-- TXT download section — shown for ASA / PROCREDIT / BBI Bank folders -->
      <ng-container *ngIf="selectedTemplateFormat === 'txt'">
        <div class="line-1"></div>

        <!-- Loading -->
        <div *ngIf="isTxtInvoicesLoading" class="no-data-wrapper">
          <mat-spinner diameter="32"></mat-spinner>
        </div>

        <!-- No TXT files found -->
        <div *ngIf="!isTxtInvoicesLoading && !txtInvoicesList.length" class="no-data-wrapper">
          <p>No TXT files found in this folder.</p>
        </div>

        <!-- Selectable TXT invoice list -->
        <p
          *ngIf="!isTxtInvoicesLoading && txtInvoicesList.length > 1 && !hasSelectedTxtInvoices()"
          class="txt-select-hint"
        >
          Click one or more files to select them for download.
        </p>
        <div
          *ngIf="!isTxtInvoicesLoading && txtInvoicesList.length"
          class="templates-list"
        >
          <div
            *ngFor="let invoice of txtInvoicesList; let i = index"
            [ngClass]="{ 'selected-template': isTxtInvoiceSelected(invoice) }"
          >
            <div class="single-template" (click)="toggleTxtInvoiceSelection(invoice)">
              <p class="title">{{ invoice.title || (txtFolderLabel + ' — File ' + (i + 1)) }}</p>
              <p class="description">{{ txtFolderLabel }}</p>
            </div>
          </div>
        </div>

        <div class="line" *ngIf="!isTxtInvoicesLoading && txtInvoicesList.length"></div>

        <!-- Template whose configured titles name the Konto / ID broj / Sifra partnera XML attributes -->
        <div
          class="xml-attr-template"
          *ngIf="!isTxtInvoicesLoading && txtInvoicesList.length && xmlAttributeTemplates.length"
        >
          <mat-form-field appearance="outline" [hideRequiredMarker]="true" class="xml-attr-template__field">
            <mat-label>Template for XML attribute names</mat-label>
            <mat-select [(ngModel)]="xmlAttributeTemplateId">
              <mat-option *ngFor="let t of xmlAttributeTemplates" [value]="t.id" [matTooltip]="t.name">
                {{ t.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <section
          class="template-run__button"
          style="gap: 8px;"
          *ngIf="!isTxtInvoicesLoading && txtInvoicesList.length"
        >
          <button
            (click)="downloadAsaBankaTxt()"
            mat-button
            class="primary-button"
            [disabled]="isLoadingButton || !hasSelectedTxtInvoices()"
            [class.disabled-run-button]="!hasSelectedTxtInvoices()"
          >
            <div class="spinner" *ngIf="isLoadingButton">
              <div>
                <mat-spinner diameter="20" color="#1E31CF"></mat-spinner>
              </div>
            </div>
            <span *ngIf="!isLoadingButton">Download TXT</span>
          </button>
          <button
            (click)="downloadAsaBankaTxtAsXml()"
            mat-button
            class="primary-button"
            [disabled]="isLoadingButton || !hasSelectedTxtInvoices()"
            [class.disabled-run-button]="!hasSelectedTxtInvoices()"
          >
            <div class="spinner" *ngIf="isLoadingButton">
              <div>
                <mat-spinner diameter="20" color="#1E31CF"></mat-spinner>
              </div>
            </div>
            <span *ngIf="!isLoadingButton">Download XML</span>
          </button>
        </section>
      </ng-container>

      <!-- BBI BAM EB XML download section -->
      <ng-container *ngIf="selectedTemplateFormat === 'xml' && isBbiBamEbFolder">
        <div class="line-1"></div>

        <div *ngIf="isXmlInvoicesLoading" class="no-data-wrapper">
          <mat-spinner diameter="32"></mat-spinner>
        </div>

        <div *ngIf="!isXmlInvoicesLoading && !xmlInvoicesList.length" class="no-data-wrapper">
          <p>No files found in this folder.</p>
        </div>

        <div
          *ngIf="!isXmlInvoicesLoading && xmlInvoicesList.length"
          class="templates-list"
        >
          <div
            *ngFor="let invoice of xmlInvoicesList; let i = index"
            [ngClass]="{ 'selected-template': isXmlInvoiceSelected(invoice) }"
          >
            <div class="single-template" (click)="toggleXmlInvoiceSelection(invoice)">
              <p class="title">{{ getInvoiceDisplayName(invoice) }}</p>
              <p class="description">BBI BAM EB</p>
            </div>
          </div>
        </div>

        <div class="line" *ngIf="!isXmlInvoicesLoading && xmlInvoicesList.length"></div>
        <section
          class="template-run__button"
          *ngIf="!isXmlInvoicesLoading && xmlInvoicesList.length"
        >
          <button
            (click)="downloadBbiBamEbXml()"
            mat-button
            class="primary-button"
            [disabled]="isLoadingButton || !hasSelectedXmlInvoices()"
            [class.disabled-run-button]="!hasSelectedXmlInvoices()"
          >
            <div class="spinner" *ngIf="isLoadingButton">
              <div>
                <mat-spinner diameter="20" color="#1E31CF"></mat-spinner>
              </div>
            </div>
            <span *ngIf="!isLoadingButton">Download XML</span>
          </button>
        </section>
      </ng-container>

      <!-- Excel / XML template selection — hidden when TXT tab or BBI BAM EB XML is active -->
      <ng-container *ngIf="selectedTemplateFormat !== 'txt' && !(selectedTemplateFormat === 'xml' && isBbiBamEbFolder)">
        <div class="no-data-wrapper" *ngIf="data?.isTemplatesEmpty">
          <img
            style="margin-top: 16px; margin-bottom: 16px"
            height="107px"
            width="100px"
            src="/assets/icons/printer.svg"
          />
          <p>
            No previously created templates,
            <br />
            create now!
          </p>
        </div>
        <section *ngIf="data?.isTemplatesEmpty" class="template-run__button">
          <a
            [routerLink]="['/templates']"
            [queryParams]="{ create_template: true, id: data.folderID }"
            (click)="closeSelectTemplateAndOpenPreviewTemplateDialog('run')"
            class="primary-button"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M6 14V8H0V6H6V0H8V6H14V8H8V14H6Z" fill="white" />
            </svg>
            &nbsp; Create Template
          </a>
        </section>
        <section *ngIf="!data?.isTemplatesEmpty">
          <div class="line-1"></div>
          <div
            class="templates-list"
            #scrollContainer
            (scroll)="onScrollInsideTemplateDialog($event)"
          >
            <div
              *ngFor="let template of data.templatesList"
              [ngClass]="{
                'selected-template': isSpecificTemplateSelected(template)
              }"
            >
              <div class="single-template" (click)="selectTemplate(template)">
                <p class="title">
                  {{ template._name }}
                </p>
                <p class="description">
                  {{ template._description }}
                </p>
              </div>
            </div>
          </div>
          <div class="line"></div>
          <section class="template-run__button">
            <button
              [disabled]="!isTemplateSelected() || loading"
              (click)="closeSelectTemplateAndOpenPreviewTemplateDialog('run')"
              mat-button
              class="primary-button"
              [class.disabled-run-button]="!isTemplateSelected()"
            >
              <div class="spinner" *ngIf="loading">
                <div>
                  <mat-spinner diameter="20" color="#1E31CF"></mat-spinner>
                </div>
              </div>
              <span *ngIf="!loading">Select template</span>
            </button>
          </section>
        </section>
      </ng-container>
    </mat-card-content>
  </mat-card>

  <mat-card
    *ngIf="isPreviewTemplate"
    class="dialog-card dialog-wrapper preview-template-wrapper"
    [class.top-to-bottom]="!isPreviewTemplate"
    [class.bottom-to-top]="isPreviewTemplate"
  >
    <mat-card-content
      aria-modal="true"
      class="dialog-content-preview d-flex fd-col gap-16"
    >
      <div class="dialog-header mb-0">
        <div class="d-flex gap-16 ai-center pointer">
          <svg
            (click)="closeAdditionalInfo()"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 5L10.4 6.4L5.8 11L22 11L22 13L5.8 13L10.4 17.6L9 19L2 12L9 5Z"
              fill="#1C1B1F"
            />
          </svg>
          <span class="dialog-heading">Download document</span>
        </div>
        <mat-icon class="h-24-w-24 cursor-pointer" (click)="closeDialogRef()"
          >close</mat-icon
        >
      </div>
      <div
        style="border-bottom: 2px solid rgba(241, 241, 241, 1); height: 2px"
      ></div>
      <div class="preview-template-description-wrapper">
        <span
          class="preview-template-error-font"
          *ngIf="doesTemplateHaveEmptyValues()"
          >There is unread data, please check before downloading the
          document.</span
        >
        <span class="preview-template-font"
          >Please select invoices that contain non-deductible VAT before
          downloading the document</span
        >
      </div>
      <div
        style="border-bottom: 2px solid rgba(241, 241, 241, 1); height: 2px"
      ></div>
      <div
        class="preview-table custom-preview-scrollbar"
        #tableRef
        (scroll)="onScrollSimple()"
      >
        <table>
          <thead>
            <tr class="table-header-row">
              <th class="d-flex fd-col vat-th">
                <span>VAT</span>
                <mat-checkbox
                  [(ngModel)]="isAllChecked"
                  (click)="toggleAll()"
                ></mat-checkbox>
              </th>
              <th *ngFor="let header of tableHeadersWithoutGoodsAndMaterial">
                {{ returnHeaderValue(header) }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let row of tableRowContent; let i = index"
              [ngClass]="{ 'empty-string-row': doesRowHaveEmptyValues(row, i) }"
            >
              <td
                *ngIf="checkRowStatus(row)"
                style="width: 39px; min-width: 39px; max-width: 39px !important"
              >
                <mat-checkbox
                  class="documents-checkbox"
                  [(ngModel)]="vatIncludedCheckbox[i]"
                  (change)="toggleFirstAndThird(row, i)"
                  [ngClass]="{ 'mat-error': doesRowHaveEmptyValues(row, i) }"
                ></mat-checkbox>
              </td>
              <td
                *ngFor="let el of row; let j = index"
                (click)="tableHeadersWithoutGoodsAndMaterial[j] !== 'konto' && tableHeadersWithoutGoodsAndMaterial[j] !== 'schema' && !isCodeHeader(tableHeadersWithoutGoodsAndMaterial[j]) && !isObrjedHeader(tableHeadersWithoutGoodsAndMaterial[j]) ? openPreviewDialog(i) : null"
              >
                <ng-container *ngIf="tableHeadersWithoutGoodsAndMaterial[j] === 'konto'; else schemaOrCodeOrOuOrRegular">
                  <input
                    #kontoInput
                    type="text"
                    class="konto-plain-input"
                    [matAutocomplete]="kontoAuto"
                    [(ngModel)]="tableRowContent[i][j]"
                    placeholder="Select konto"
                  />
                  <mat-autocomplete
                    #kontoAuto="matAutocomplete"
                    (optionSelected)="onKontoSelected($event.option.value, i, j)"
                  >
                    <mat-option
                      *ngFor="let account of getFilteredAccounts(kontoInput.value)"
                      [value]="account.konto"
                      style="font-size: 12px;"
                      [matTooltip]="account.konto + ' – ' + account.nazivKonta"
                      matTooltipPosition="right"
                    >
                      {{ account.konto }} – {{ account.nazivKonta }}
                    </mat-option>
                  </mat-autocomplete>
                </ng-container>
                <ng-template #schemaOrCodeOrOuOrRegular>
                  <ng-container *ngIf="tableHeadersWithoutGoodsAndMaterial[j] === 'schema'; else codeOrOuOrRegular">
                    <input
                      #schemaInput
                      type="text"
                      class="konto-plain-input"
                      [matAutocomplete]="schemaAuto"
                      [(ngModel)]="tableRowContent[i][j]"
                      placeholder="Select schema"
                    />
                    <mat-autocomplete
                      #schemaAuto="matAutocomplete"
                      (optionSelected)="onSchemaSelected($event.option.value, i, j)"
                    >
                      <mat-option
                        *ngFor="let schema of getFilteredSchemas(schemaInput.value)"
                        [value]="schema.schema"
                        style="font-size: 12px;"
                        [matTooltip]="schema.schema + ' – ' + schema.nazivSheme"
                        matTooltipPosition="right"
                      >
                        {{ schema.schema }} – {{ schema.nazivSheme }}
                      </mat-option>
                    </mat-autocomplete>
                  </ng-container>
                </ng-template>
                <ng-template #codeOrOuOrRegular>
                  <ng-container *ngIf="isCodeHeader(tableHeadersWithoutGoodsAndMaterial[j]); else ouOrRegular">
                    <input
                      #codeInput
                      type="text"
                      class="konto-plain-input"
                      [matAutocomplete]="codeAuto"
                      [(ngModel)]="tableRowContent[i][j]"
                      placeholder="Select code"
                    />
                    <mat-autocomplete
                      #codeAuto="matAutocomplete"
                      (optionSelected)="onCodeSelected($event.option.value, i, j)"
                    >
                      <mat-option
                        *ngFor="let cb of getFilteredCodebookItems(codeInput.value)"
                        [value]="cb.code"
                        style="font-size: 12px;"
                        [matTooltip]="cb.code + ' – ' + cb.companyName"
                        matTooltipPosition="right"
                      >
                        {{ cb.code }} – {{ cb.companyName }}
                      </mat-option>
                    </mat-autocomplete>
                  </ng-container>
                </ng-template>
                <ng-template #ouOrRegular>
                  <ng-container *ngIf="isObrjedHeader(tableHeadersWithoutGoodsAndMaterial[j]); else regularCell">
                    <input
                      #ouInput
                      type="text"
                      class="konto-plain-input"
                      [matAutocomplete]="ouAuto"
                      [(ngModel)]="tableRowContent[i][j]"
                      placeholder="Select organizational unit"
                    />
                    <mat-autocomplete
                      #ouAuto="matAutocomplete"
                      (optionSelected)="onObrjedSelected($event.option.value, i, j)"
                    >
                      <mat-option
                        *ngFor="let unit of getFilteredOrganizationalUnits(ouInput.value)"
                        [value]="unit.code"
                        style="font-size: 12px;"
                        [matTooltip]="unit.code + ' – ' + unit.name"
                        matTooltipPosition="right"
                      >
                        {{ unit.code }} – {{ unit.name }}
                      </mat-option>
                    </mat-autocomplete>
                  </ng-container>
                </ng-template>
                <ng-template #regularCell>{{ el }}</ng-template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div style="flex-grow: 1"></div>
      <div class="starting-index-download-wrapper">
        <span class="kuf-no-font" *ngIf="documentIndexValue.documentIndex">{{
          documentIndexValue.documentIndex
        }}</span>
        <input
          *ngIf="documentIndexValue.documentIndex"
          type="number"
          class="starting-index-input-wrapper"
          (input)="onInputChange($event)"
          [(ngModel)]="startingIndex"
          pattern="[0-9]+"
          (keydown)="onInputKeyDown($event)"
        />
        <button
          [class.loading]="isLoadingButton"
          [style.background]="isLoadingButton ? 'rgba(30, 49, 207, 0.32)' : ''"
          style="margin: 0; align-self: flex-end"
          class="primary-button action-download-button"
          [matMenuTriggerFor]="downloadMenu"
        >
          <div *ngIf="!isLoadingButton; else loadingButton" class="flex-jc-ai">
            <span>{{
              doesTableHaveEmptyValues() ? "Skip and download" : "Download"
            }}</span>
            <mat-icon style="margin-left: 4px;">arrow_drop_down</mat-icon>
          </div>
          <ng-template #loadingButton>
            <svg
              class="rotate-svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.9277 3.92822C10.1667 3.92822 8.4548 4.50932 7.05764 5.5814C5.66049 6.65347 4.65613 8.1566 4.20033 9.85767C3.74453 11.5587 3.86276 13.3627 4.5367 14.9897C5.21063 16.6167 6.4026 17.9759 7.92773 18.8564C9.45287 19.737 11.2259 20.0896 12.9719 19.8598C14.718 19.6299 16.3393 18.8303 17.5846 17.5851C18.8299 16.3398 19.6294 14.7184 19.8593 12.9724C20.0892 11.2264 19.7365 9.45336 18.8559 7.92822"
                stroke="#1E31CF"
                stroke-width="4"
                stroke-miterlimit="3.8637"
              />
            </svg>
          </ng-template>
        </button>
        <mat-menu #downloadMenu="matMenu">
          <button mat-menu-item (click)="skipAndDownload('preview')">
            <mat-icon>download</mat-icon>
            <span>Download excel file</span>
          </button>
          <button mat-menu-item (click)="sendToYourBooks()">
            <mat-icon>cloud_upload</mat-icon>
            <span>Send to Your Books</span>
          </button>
          <button mat-menu-item (click)="processPosIzvod()">
            <mat-icon>payment</mat-icon>
            <span>Process POS Izvodi</span>
          </button>
        </mat-menu>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card
    *ngIf="isDownloadPreview"
    class="dialog-card dialog-wrapper download-template-wrapper"
    [class.top-to-bottom]="!isDownloadPreview"
    [class.bottom-to-top]="isDownloadPreview"
  >
    <mat-card-content
      class="dialog-download-content-preview d-flex fd-col gap-16"
    >
      <div class="wrapper">
        <div class="initial-step">
          <div class="initial-step-header">
            <div class="header-text-wrapper" style="width: 100%">
              <div style="display: flex; align-items: center; gap: 16px">
                <svg
                  class="pointer"
                  (click)="closeDownloadTemplate()"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 5L10.4 6.4L5.8 11L22 11L22 13L5.8 13L10.4 17.6L9 19L2 12L9 5Z"
                    fill="#1C1B1F"
                  />
                </svg>
                <span class="initial-step-header-main font">
                  Document preview
                </span>
                <span id="assigned-to-email" class="initial-step-header-main font">
                  <ng-container *ngIf="data.duplicatedArray[imageIndex].invoiceUserAssignments?.items?.length">
                    Assigned to: 
                    <mat-chip-list>
                      <mat-chip 
                        *ngFor="let assignment of data.duplicatedArray[imageIndex].invoiceUserAssignments.items"
                        [removable]="true"
                        class="email-chip"
                        (removed)="unassignUser(assignment.id)"
                      >
                        <mat-icon class="chip-icon">person</mat-icon>
                        {{ assignment.email }}
                        <mat-icon matChipRemove>cancel</mat-icon>
                      </mat-chip>
                    </mat-chip-list>
                  </ng-container>
                </span>
              </div>
              <button
                class="primary-button goods-and-material-button"
                *ngIf="areGoodsAndMaterialFieldsPresent()"
              >
                <div
                  (click)="
                    openPreviewGoodsAndMaterialDialog(
                      data.duplicatedArray[imageIndex]
                    )
                  "
                  style="display: flex; gap: 8px; align-items: center"
                >
                  <img
                    [src]="localImages.keyboardTab"
                    class="button-icon"
                    alt="icon"
                  />
                  <span>{{ "Goods and material" }}</span>
                </div>
                <ng-template #loadingButton>
                  <svg
                    class="rotate-svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.9277 3.92822C10.1667 3.92822 8.4548 4.50932 7.05764 5.5814C5.66049 6.65347 4.65613 8.1566 4.20033 9.85767C3.74453 11.5587 3.86276 13.3627 4.5367 14.9897C5.21063 16.6167 6.4026 17.9759 7.92773 18.8564C9.45287 19.737 11.2259 20.0896 12.9719 19.8598C14.718 19.6299 16.3393 18.8303 17.5846 17.5851C18.8299 16.3398 19.6294 14.7184 19.8593 12.9724C20.0892 11.2264 19.7365 9.45336 18.8559 7.92822"
                      stroke="#1E31CF"
                      stroke-width="4"
                      stroke-miterlimit="3.8637"
                    />
                  </svg>
                </ng-template>
              </button>
            </div>
          </div>
          <span
            class="error-on-download"
            *ngIf="
              isErrorPresentOnCurrentInvoice(
                data.duplicatedArray[imageIndex].inputs
              )
            "
          >
            There is unread data, please check before downloading the document.
          </span>
          <div
            class="carousel-wrapper"
            [class.mt-24]="
              isErrorPresentOnCurrentInvoice(
                data.duplicatedArray[imageIndex].inputs
              )
            "
          >
            <div class="slide-wrapper">
              <div class="slide">
                <div class="rotating-image-wrapper">
                  <div class="image-container-wrapper">
                    <div class="zoom-controls">
                      <button class="zoom-button plus" (click)="zoomIn()">
                        +
                      </button>
                      <button class="zoom-button minus" (click)="zoomOut()">
                        -
                      </button>
                    </div>
                    <div
                      class="rotating-image"
                      id="rotatingImage"
                      [@rotatedState]="{ value: currentAngle.toString() }"
                    >
                      <ng-container
                        #outlet
                        [ngTemplateOutlet]="content"
                      ></ng-container>

                      <ng-template #content>
                        <div class="image-container">
                          <!-- TXT File Preview -->
                          <ng-container *ngIf="isTxtFile(data.duplicatedArray[imageIndex]?.name)">
                            <ng-container *ngIf="data.duplicatedArray[imageIndex]?.thumbnailPath; else txtPlaceholder">
                              <img
                                class="cursor-zoom uploaded-image"
                                [src]="data.duplicatedArray[imageIndex]?.thumbnailPath"
                                alt="TXT Document Preview"
                              />
                            </ng-container>
                            <ng-template #txtPlaceholder>
                              <div class="txt-file-preview">
                                <div class="txt-file-header">
                                  <img [src]="localImages.textFileDocument" alt="TXT File" class="txt-icon" />
                                  <span class="txt-filename">{{ data.duplicatedArray[imageIndex]?.name }}</span>
                                </div>
                                <div class="txt-content-wrapper" *ngIf="!txtFileLoading">
                                  <pre class="txt-content">{{ txtFileContent || 'Loading content...' }}</pre>
                                </div>
                                <div class="txt-loading" *ngIf="txtFileLoading">
                                  <mat-spinner diameter="30"></mat-spinner>
                                  <span>Loading text file...</span>
                                </div>
                              </div>
                            </ng-template>
                          </ng-container>
                          <!-- Image/PDF Preview -->
                          <img
                            *ngIf="!isTxtFile(data.duplicatedArray[imageIndex]?.name)"
                            #imageElement
                            class="cursor-zoom uploaded-image"
                            [src]="
                              data.duplicatedArray[imageIndex]?.thumbnailPath ||
                              localImages.fileDocument
                            "
                            alt="Document Preview"
                            (click)="
                              openDocumentEmitter(
                                data.duplicatedArray[imageIndex].name.endsWith(
                                  '.pdf'
                                ),
                                data.duplicatedArray[imageIndex].name
                              )
                            "
                          />

                          <div
                            class="bounding-box-overlay"
                            [style.transform]="overlayTransform"
                            [style.transform-origin]="transformOrigin"
                          >
                            <div
                              *ngFor="let block of textBlocks"
                              class="bounding-box"
                              [ngClass]="{
                                selected: selectedTextBlock === block
                              }"
                              [style.left]="block.pxLeft"
                              [style.top]="block.pxTop"
                              [style.width]="block.pxWidth"
                              [style.height]="block.pxHeight"
                              (click)="selectTextBlock(block)"
                              [title]="block.Text"
                            ></div>
                          </div>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </div>

                <div class="input-wrapper" #inputWrapper>
                  <div
                    *ngFor="
                      let input of filterAccordingToTemplate(
                        data.duplicatedArray[imageIndex]?.inputs
                      )
                    "
                    class="slide-inputs"
                  >
                    <ng-container
                      *ngIf="!isGoodsAndMaterialField(input.heading)"
                    >
                      <!-- Konto field: autocomplete dropdown -->
                      <ng-container *ngIf="input.heading === 'konto'; else kontoElse">
                        <mat-form-field
                          class="form-field"
                          appearance="outline"
                          [hideRequiredMarker]="true"
                          [ngClass]="{ 'empty-input': !input.value }"
                        >
                          <mat-label [ngClass]="{ 'empty-input': !input.value }">
                            {{ returnHeaderValue(input.heading) }}
                          </mat-label>
                          <input
                            #previewKontoInput
                            type="text"
                            matInput
                            [matAutocomplete]="previewKontoAuto"
                            [(ngModel)]="input.value"
                            placeholder="Select konto"
                          />
                          <mat-autocomplete
                            #previewKontoAuto="matAutocomplete"
                            (optionSelected)="onPreviewKontoSelected($event.option.value, input)"
                          >
                            <mat-option
                              *ngFor="let account of getFilteredAccounts(previewKontoInput.value)"
                              [value]="account.konto"
                              style="font-size: 12px;"
                              [matTooltip]="account.konto + ' – ' + account.nazivKonta"
                              matTooltipPosition="right"
                            >
                              {{ account.konto }} – {{ account.nazivKonta }}
                            </mat-option>
                          </mat-autocomplete>
                        </mat-form-field>
                      </ng-container>

                      <ng-template #kontoElse>
                        <!-- Schema field: autocomplete dropdown from the Schema codebook -->
                        <ng-container *ngIf="input.heading === 'schema'; else schemaElse">
                          <mat-form-field
                            class="form-field"
                            appearance="outline"
                            [hideRequiredMarker]="true"
                            [ngClass]="{ 'empty-input': !input.value }"
                          >
                            <mat-label [ngClass]="{ 'empty-input': !input.value }">
                              {{ returnHeaderValue(input.heading) }}
                            </mat-label>
                            <input
                              #previewSchemaInput
                              type="text"
                              matInput
                              [matAutocomplete]="previewSchemaAuto"
                              [(ngModel)]="input.value"
                              placeholder="Select schema"
                            />
                            <mat-autocomplete
                              #previewSchemaAuto="matAutocomplete"
                              (optionSelected)="onPreviewSchemaSelected($event.option.value, input)"
                            >
                              <mat-option
                                *ngFor="let schema of getFilteredSchemas(previewSchemaInput.value)"
                                [value]="schema.schema"
                                style="font-size: 12px;"
                                [matTooltip]="schema.schema + ' – ' + schema.nazivSheme"
                                matTooltipPosition="right"
                              >
                                {{ schema.schema }} – {{ schema.nazivSheme }}
                              </mat-option>
                            </mat-autocomplete>
                          </mat-form-field>
                        </ng-container>
                      </ng-template>

                      <ng-template #schemaElse>
                        <ng-container *ngIf="isCodeHeader(input.heading); else codeOrObrjed">
                          <mat-form-field
                            class="form-field"
                            appearance="outline"
                            [hideRequiredMarker]="true"
                            [ngClass]="{ 'empty-input': !input.value }"
                          >
                            <mat-label [ngClass]="{ 'empty-input': !input.value }">
                              {{ returnHeaderValue(input.heading) }}
                            </mat-label>
                            <input
                              #previewCodeInput
                              type="text"
                              matInput
                              [matAutocomplete]="previewCodeAuto"
                              [(ngModel)]="input.value"
                              placeholder="Select code"
                            />
                            <mat-autocomplete
                              #previewCodeAuto="matAutocomplete"
                              (optionSelected)="onPreviewCodeSelected($event.option.value, input)"
                            >
                              <mat-option
                                *ngFor="let cb of getFilteredCodebookItems(previewCodeInput.value)"
                                [value]="cb.code"
                                style="font-size: 12px;"
                                [matTooltip]="cb.code + ' – ' + cb.companyName"
                                matTooltipPosition="right"
                              >
                                {{ cb.code }} – {{ cb.companyName }}
                              </mat-option>
                            </mat-autocomplete>
                          </mat-form-field>
                        </ng-container>
                      </ng-template>

                      <ng-template #codeOrObrjed>
                        <ng-container *ngIf="isObrjedHeader(input.heading); else regularInput">
                          <mat-form-field
                            class="form-field"
                            appearance="outline"
                            [hideRequiredMarker]="true"
                            [ngClass]="{ 'empty-input': !input.value }"
                          >
                            <mat-label [ngClass]="{ 'empty-input': !input.value }">
                              {{ returnHeaderValue(input.heading) }}
                            </mat-label>
                            <input
                              #previewOuInput
                              type="text"
                              matInput
                              [matAutocomplete]="previewOuAuto"
                              [(ngModel)]="input.value"
                              placeholder="Select organizational unit"
                            />
                            <mat-autocomplete
                              #previewOuAuto="matAutocomplete"
                              (optionSelected)="onPreviewObrjedSelected($event.option.value, input)"
                            >
                              <mat-option
                                *ngFor="let unit of getFilteredOrganizationalUnits(previewOuInput.value)"
                                [value]="unit.code"
                                style="font-size: 12px;"
                                [matTooltip]="unit.code + ' – ' + unit.name"
                                matTooltipPosition="right"
                              >
                                {{ unit.code }} – {{ unit.name }}
                              </mat-option>
                            </mat-autocomplete>
                          </mat-form-field>
                        </ng-container>
                      </ng-template>

                      <!-- All other fields: plain text input -->
                      <ng-template #regularInput>
                        <mat-form-field
                          class="form-field"
                          appearance="outline"
                          [hideRequiredMarker]="true"
                          [ngClass]="{ 'empty-input': !input.value }"
                        >
                          <mat-label [ngClass]="{ 'empty-input': !input.value }">
                            {{ returnHeaderValue(input.heading) }}
                          </mat-label>
                          <input
                            type="text"
                            [placeholder]="
                              input.heading === 'invoiceDate' ||
                              input.heading === 'dueDate'
                                ? 'DD.MM.YYYY.'
                                : 'Molimo unesite podatke'
                            "
                            matInput
                            [(ngModel)]="input.value"
                            (ngModelChange)="onPreviewIdOrVatChange(input.heading, $event)"
                          />
                        </mat-form-field>
                      </ng-template>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex jc-between ai-center">
          <div class="d-flex gap-60">
            <span
              (click)="changeStep('previous')"
              class="majorant save-changes-button-font unselectable centered"
              [class.disabled-span]="imageIndex === 0"
              style="cursor: pointer; color: #1b1b1f"
              >Previous document</span
            >
            <span
              (click)="changeStep('next')"
              class="majorant save-changes-button-font unselectable centered"
              [class.disabled-span]="
                imageIndex === data.duplicatedArray.length - 1
              "
              style="cursor: pointer; color: #1b1b1f"
              >Next document</span
            >
            <div class="rotate-icon-wrapper">
              <svg
                class="pointer rotate-icon unselectable"
                (click)="rotateImage()"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.89 5.0799C14.02 4.8199 13.06 4.6499 12 4.6499C7.20996 4.6499 3.32996 8.5299 3.32996 13.3199C3.32996 18.1199 7.20996 21.9999 12 21.9999C16.79 21.9999 20.67 18.1199 20.67 13.3299C20.67 11.5499 20.13 9.8899 19.21 8.5099"
                  stroke="#292D32"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.13 5.32L13.24 2"
                  stroke="#292D32"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.13 5.32007L12.76 7.78007"
                  stroke="#292D32"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <button
            [class.loading]="isLoadingButton"
            [style.background]="
              isLoadingButton ? 'rgba(30, 49, 207, 0.32)' : ''
            "
            class="primary-button action-download-button"
            [matMenuTriggerFor]="downloadMenuPreview"
          >
            <div
              *ngIf="!isLoadingButton; else loadingButton"
              class="flex-jc-ai"
            >
              <span>{{
                doesTableHaveEmptyValues() ? "Skip and download" : "Download"
              }}</span>
              <mat-icon style="margin-left: 4px;">arrow_drop_down</mat-icon>
            </div>
            <ng-template #loadingButton>
              <svg
                class="rotate-svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.9277 3.92822C10.1667 3.92822 8.4548 4.50932 7.05764 5.5814C5.66049 6.65347 4.65613 8.1566 4.20033 9.85767C3.74453 11.5587 3.86276 13.3627 4.5367 14.9897C5.21063 16.6167 6.4026 17.9759 7.92773 18.8564C9.45287 19.737 11.2259 20.0896 12.9719 19.8598C14.718 19.6299 16.3393 18.8303 17.5846 17.5851C18.8299 16.3398 19.6294 14.7184 19.8593 12.9724C20.0892 11.2264 19.7365 9.45336 18.8559 7.92822"
                  stroke="#1E31CF"
                  stroke-width="4"
                  stroke-miterlimit="3.8637"
                />
              </svg>
            </ng-template>
          </button>
          <mat-menu #downloadMenuPreview="matMenu">
            <button mat-menu-item (click)="skipAndDownload('details')">
              <mat-icon>download</mat-icon>
              <span>Download excel file</span>
            </button>
            <button mat-menu-item (click)="sendToYourBooks()">
              <mat-icon>cloud_upload</mat-icon>
              <span>Send to Your Books</span>
            </button>
            <button mat-menu-item (click)="processPosIzvod()">
              <mat-icon>payment</mat-icon>
              <span>Process POS Izvodi</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card
    *ngIf="isPreviewGoodsAndMaterial"
    class="dialog-card dialog-wrapper preview-goods-and-materials-wrapper"
    [class.top-to-bottom]="!isPreviewGoodsAndMaterial"
    [class.bottom-to-top]="isPreviewGoodsAndMaterial"
    style="overflow-y: auto; overflow-x: hidden"
  >
    <mat-card-content
      aria-modal="true"
      class="goods-and-material-dialog-content-preview d-flex fd-col gap-16"
    >
      <div class="header-text-wrapper" style="width: 100%; display: flex; align-items: center; justify-content: space-between; gap: 16px">
        <div style="display: flex; align-items: center; gap: 16px">
          <svg
            class="pointer"
            (click)="closePreviewGoodsAndMaterialDialog()"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 5L10.4 6.4L5.8 11L22 11L22 13L5.8 13L10.4 17.6L9 19L2 12L9 5Z"
              fill="#1C1B1F"
            />
          </svg>
          <span class="initial-step-header-main font">
            Goods and material
          </span>
          <span
            *ngIf="isBankStatement() && bankCompanyAccount"
            class="bank-account-badge"
            matTooltip="Broj računa iz izvoda; pravila važe samo za ovaj račun"
          >
            Račun: {{ bankCompanyAccount }}
          </span>
          <mat-spinner *ngIf="bankXmlLoading" diameter="18"></mat-spinner>
        </div>
        <button
          *ngIf="isBankStatement() && bankCompanyAccount"
          class="bank-rules-button"
          type="button"
          (click)="openBankRulesListDialog()"
        >
          <mat-icon>rule</mat-icon>
          <span>Pravila za stavke</span>
        </button>
      </div>

      <div>
        <div style="display: flex; gap: 12px">
          <div class="rotating-image-wrapper">
            <div class="image-container" #imageWheelContainer>
              <div class="zoom-controls">
                <button class="zoom-button plus" (click)="zoomIn()">+</button>
                <button class="zoom-button minus" (click)="zoomOut()">-</button>
              </div>

              <div
                class="rotating-image"
                id="rotatingImage"
                [@rotatedState]="{ value: currentAngle.toString() }"
              >
                <!-- TXT File Preview for Goods and Materials -->
                <ng-container *ngIf="isTxtFile(data.duplicatedArray[imageIndex]?.name)">
                  <ng-container *ngIf="data.duplicatedArray[imageIndex]?.thumbnailPath; else txtPlaceholderGM">
                    <img
                      class="cursor-zoom uploaded-image"
                      [src]="data.duplicatedArray[imageIndex]?.thumbnailPath"
                      alt="TXT Document Preview"
                    />
                  </ng-container>
                  <ng-template #txtPlaceholderGM>
                    <div class="txt-file-preview">
                      <div class="txt-file-header">
                        <img [src]="localImages.textFileDocument" alt="TXT File" class="txt-icon" />
                        <span class="txt-filename">{{ data.duplicatedArray[imageIndex]?.name }}</span>
                      </div>
                      <div class="txt-content-wrapper" *ngIf="!txtFileLoading">
                        <pre class="txt-content">{{ txtFileContent || 'Loading content...' }}</pre>
                      </div>
                      <div class="txt-loading" *ngIf="txtFileLoading">
                        <mat-spinner diameter="30"></mat-spinner>
                        <span>Loading text file...</span>
                      </div>
                    </div>
                  </ng-template>
                </ng-container>
                <!-- Image/PDF Preview for Goods and Materials -->
                <img
                  *ngIf="!isTxtFile(data.duplicatedArray[imageIndex]?.name)"
                  #imageElement
                  class="cursor-zoom uploaded-image"
                  [src]="
                    data.duplicatedArray[imageIndex]?.thumbnailPath ||
                    localImages.fileDocument
                  "
                  alt="Document Preview"
                  (click)="
                    openDocumentEmitter(
                      data.duplicatedArray[imageIndex].name.endsWith('.pdf'),
                      data.duplicatedArray[imageIndex].name
                    )
                  "
                  (load)="onGoodsAndMaterialsImageLoad()"
                />

                <div
                  class="bounding-box-overlay"
                  [style.transform]="overlayTransform"
                  [style.transform-origin]="transformOrigin"
                >
                  <div
                    *ngFor="let block of textBlocks"
                    class="bounding-box"
                    [ngClass]="{
                      selected: selectedTextBlock === block
                    }"
                    [style.left]="block.pxLeft"
                    [style.top]="block.pxTop"
                    [style.width]="block.pxWidth"
                    [style.height]="block.pxHeight"
                    (click)="selectTextBlock(block)"
                    [title]="block.Text"
                  ></div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="preview-goods-and-material-table custom-preview-scrollbar"
            #tableRef
            (scroll)="onScrollSimple()"
          >
            <table class="custom-table">
              <thead>
                <tr class="table-header-row">
                  <th
                    resizable
                    *ngFor="let header of extractGoodsAndMaterialFields()"
                    style="
                      padding-left: 8px;
                      padding-right: 8px;
                      white-space: normal;
                      word-wrap: break-word;
                      overflow: hidden;
                      text-align: center;
                    "
                  >
                    <div style="padding: 8px">
                      {{ returnHeaderValue(header) }}
                    </div>
                  </th>
                  <th
                    *ngIf="showBankCheckboxColumn('bankUseCash')"
                    style="
                      padding-left: 8px;
                      padding-right: 8px;
                      white-space: normal;
                      word-wrap: break-word;
                      overflow: hidden;
                      text-align: center;
                      min-width: 120px;
                    "
                  >
                    <div style="padding: 8px">
                      U gotovu
                    </div>
                  </th>
                  <th
                    *ngIf="showBankCheckboxColumn('bankSyncToEPO')"
                    style="
                      padding-left: 8px;
                      padding-right: 8px;
                      white-space: normal;
                      word-wrap: break-word;
                      overflow: hidden;
                      text-align: center;
                      min-width: 140px;
                    "
                  >
                    <div style="padding: 8px">
                      Sync Ostalo to EPO/KP
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="
                    let row of tableRowContent;
                    let i = index;
                    trackBy: trackByFn
                  "
                >
                  <td
                    *ngFor="let el of row; let j = index; trackBy: trackByFn"
                    class="custom-cell"
                  >
                    <!-- Bank statement (izvod) cells -->
                    <ng-container *ngIf="tableHeaders[j] === 'bankKonto'">
                      <input
                        #bankKontoInput
                        type="text"
                        class="konto-plain-input"
                        [matAutocomplete]="bankKontoAuto"
                        [(ngModel)]="tableRowContent[i][j]"
                        (ngModelChange)="onBankKontoEdited(i)"
                        placeholder="Konto"
                      />
                      <mat-autocomplete
                        #bankKontoAuto="matAutocomplete"
                        [displayWith]="kontoDisplayFn"
                        (optionSelected)="onBankKontoSelected($event.option.value, i, j)"
                      >
                        <mat-option
                          *ngFor="let a of getFilteredAccounts(bankKontoInput.value)"
                          [value]="a.konto"
                          style="font-size: 12px;"
                          [matTooltip]="a.konto + ' – ' + a.nazivKonta"
                          matTooltipPosition="right"
                        >
                          {{ a.konto }} – {{ a.nazivKonta }}
                        </mat-option>
                      </mat-autocomplete>
                    </ng-container>
                    <ng-container *ngIf="tableHeaders[j] === 'bankSifraPartnera'">
                      <input
                        #bankPartnerInput
                        type="text"
                        class="konto-plain-input"
                        [matAutocomplete]="bankPartnerAuto"
                        [(ngModel)]="tableRowContent[i][j]"
                        (ngModelChange)="onBankPartnerEdited(i)"
                        placeholder="Partner"
                      />
                      <mat-autocomplete
                        #bankPartnerAuto="matAutocomplete"
                        [displayWith]="codeDisplayFn"
                        (optionSelected)="onBankPartnerSelected($event.option.value, i, j)"
                      >
                        <mat-option
                          *ngFor="let cb of getFilteredCodebookItems(bankPartnerInput.value)"
                          [value]="cb.code"
                          style="font-size: 12px;"
                          [matTooltip]="cb.code + ' – ' + cb.companyName + (cb.idNumber ? ' (' + cb.idNumber + ')' : '')"
                          matTooltipPosition="right"
                        >
                          {{ cb.code }} – {{ cb.companyName }}
                        </mat-option>
                      </mat-autocomplete>
                    </ng-container>
                    <ng-container *ngIf="tableHeaders[j] === 'bankOpis1'">
                      <span
                        class="bank-opis1-link"
                        [class.disabled]="!bankCompanyAccount"
                        matTooltip="Kreiraj pravilo za ovaj račun"
                        (click)="openBankRuleDialog(i)"
                      >{{ tableRowContent[i][j] || '–' }}</span>
                    </ng-container>
                    <ng-container *ngIf="isBankReadonlyField(tableHeaders[j]) && tableHeaders[j] !== 'bankOpis1'">
                      <span class="bank-readonly-cell" [matTooltip]="tableRowContent[i][j]">{{ tableRowContent[i][j] }}</span>
                    </ng-container>

                    <ng-container *ngIf="tableHeaders[j] === 'articleCode'; else regularGoodsCell">
                      <input
                        #articleInput
                        type="text"
                        class="konto-plain-input"
                        [matAutocomplete]="articleAuto"
                        [(ngModel)]="tableRowContent[i][j]"
                        placeholder="Select article"
                      />
                      <mat-autocomplete
                        #articleAuto="matAutocomplete"
                        (optionSelected)="onArticleCodeSelected($event.option.value, i)"
                      >
                        <mat-option
                          *ngFor="let pl of getFilteredPriceListItems(articleInput.value)"
                          [value]="pl.productCode"
                          style="font-size: 12px;"
                          [matTooltip]="pl.productCode + ' – ' + pl.productName"
                          matTooltipPosition="right"
                        >
                          {{ pl.productCode }} – {{ pl.productName }}
                        </mat-option>
                      </mat-autocomplete>
                    </ng-container>
                    <ng-template #regularGoodsCell>
                      <mat-form-field
                        *ngIf="!isGoodsBankSpecialCell(tableHeaders[j])"
                        appearance="outline"
                        class="form-field"
                      >
                        <input matInput [(ngModel)]="tableRowContent[i][j]" />
                      </mat-form-field>
                    </ng-template>
                  </td>
                  <td
                    *ngIf="showBankCheckboxColumn('bankUseCash')"
                    class="custom-cell"
                    style="text-align: center;"
                  >
                    <mat-checkbox [(ngModel)]="rowUseCash[i]" color="primary"></mat-checkbox>
                  </td>
                  <td
                    *ngIf="showBankCheckboxColumn('bankSyncToEPO')"
                    class="custom-cell"
                    style="text-align: center;"
                  >
                    <mat-checkbox [(ngModel)]="rowSyncToEPO[i]" color="primary"></mat-checkbox>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div style="height: 100%; display: flex; flex-direction: column">
        <div
          style="
            width: 100%;
            max-width: 400px;
            margin-top: 24px;
            flex-grow: 1;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            gap: 12px;
          "
        >
          <button
            [class.loading]="isLoadingButton"
            [style.background]="
              isLoadingButton ? 'rgba(30, 49, 207, 0.32)' : ''
            "
            class="primary-button"
            (click)="saveAndBack()"
            [disabled]="!hasChanges()"
          >
            <div
              *ngIf="!isLoadingButton; else loadingButton"
              class="flex-jc-ai"
            >
              <span>Save and back</span>
            </div>
            <ng-template #loadingButton>
              <svg
                class="rotate-svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.9277 3.92822C10.1667 3.92822 8.4548 4.50932 7.05764 5.5814C5.66049 6.65347 4.65613 8.1566 4.20033 9.85767C3.74453 11.5587 3.86276 13.3627 4.5367 14.9897C5.21063 16.6167 6.4026 17.9759 7.92773 18.8564C9.45287 19.737 11.2259 20.0896 12.9719 19.8598C14.718 19.6299 16.3393 18.8303 17.5846 17.5851C18.8299 16.3398 19.6294 14.7184 19.8593 12.9724C20.0892 11.2264 19.7365 9.45336 18.8559 7.92822"
                  stroke="#1E31CF"
                  stroke-width="4"
                  stroke-miterlimit="3.8637"
                />
              </svg>
            </ng-template>
          </button>
          <div class="rotate-icon-wrapper">
            <svg
              class="pointer rotate-icon unselectable"
              (click)="rotateImage()"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.89 5.0799C14.02 4.8199 13.06 4.6499 12 4.6499C7.20996 4.6499 3.32996 8.5299 3.32996 13.3199C3.32996 18.1199 7.20996 21.9999 12 21.9999C16.79 21.9999 20.67 18.1199 20.67 13.3299C20.67 11.5499 20.13 9.8899 19.21 8.5099"
                stroke="#292D32"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
<div class="dialog-background" (click)="closeDialogRef()"></div>
